import OnlineLogo from './assets/online.svg?react';
import PublisherLogo from './assets/publisher.svg?react';
import { b, e } from './style.css';

type LogoImage = 'online' | 'publisher';

const logos = {
    online: OnlineLogo,
    publisher: PublisherLogo,
};

const Logo = ({ logoLink, onLogoClick, logo = 'online' }: Logo.Props) => {
    const Component = logoLink ? 'a' : 'div';
    const Logo = logos[logo];

    return (
        <Component
            className={e.logoBox}
            href={logoLink}
            onClick={onLogoClick}
        >
            <Logo className={e.logo} />
        </Component>
    );
};

export function Header(props: Header.Props) {
    const { helpMenu, logo, logoLink, onLogoClick } = props;

    return (
        <article className={b.name}>
            <div className={e.wrapper}>
                <Logo
                    logo={logo}
                    logoLink={logoLink}
                    onLogoClick={onLogoClick}
                />
                <div className={e.helpMenu}>{helpMenu}</div>
            </div>
        </article>
    );
}

namespace Logo {
    export interface Props {
        logoLink?: Header.Props['logoLink'];
        logo: Header.Props['logo'];
        onLogoClick?: Header.Props['onLogoClick'];
    }
}

export namespace Header {
    export interface Props {
        logoLink?: string;
        logo?: LogoImage;
        onLogoClick?: React.MouseEventHandler;
        helpMenu?: React.ReactNode;
    }
}
